import {
  profile
} from '../constants';

/**
 * Import constants
 */
const {
  SET_PROFILE_INFO,
} = profile;

/**
 * Action creators
 */
const actions = {
  setProfileInfo: (data) => ({ type: SET_PROFILE_INFO, data }),
};

/**
 * Set Profile info
 */
export const setProfileInfo = (data) => (dispatch) => dispatch(actions.setProfileInfo(data));
